import styled from 'styled-components';

import ImageEditor from '../../../blocks/ImageEditor';

const EditorControls = styled(ImageEditor.Controls)`
  justify-content: flex-end;
`;

export default EditorControls;
